import React from 'react';
import {SignUpComponent} from '../../components';

export const SignUp: React.FC = React.memo(() => {
  return <SignUpComponent />;
});
